import { CSSObject, styled, keyframes } from 'libs/ui/styled';

const moveInCircle = keyframes`
  0% {
    transform: rotate(0deg);
  }
  50% {
    transform: rotate(180deg);
  }
  100% {
    transform: rotate(360deg);
  }
`;

const moveVertical = keyframes`
  0% {
    transform: translateY(-50%);
  }
  50% {
    transform: translateY(50%);
  }
  100% {
    transform: translateY(-50%);
  }
`;

const moveHorizontal = keyframes`
  0% {
    transform: translateX(-50%) translateY(-10%);
  }
  50% {
    transform: translateX(50%) translateY(10%);
  }
  100% {
    transform: translateX(-50%) translateY(-10%);
  }
`;

export const GradientBackgroundRoot = styled('div')(({ theme }) => ({
  '--color-bg1': theme.palette.mode === 'dark' ? '#200604' : '#dff9fb',
  '--color-bg2': theme.palette.mode === 'dark' ? '#000000' : '#ffffff',
  '--color1': theme.palette.mode === 'dark' ? '151, 146, 31' : '104, 109, 224',
  '--color2': theme.palette.mode === 'dark' ? '129, 41, 32' : '126, 214, 223',
  '--color3': theme.palette.mode === 'dark' ? '32, 6, 4' : '223, 249, 251',
  '--color4': theme.palette.mode === 'dark' ? '0, 134, 134' : '255, 121, 121',
  '--color5': theme.palette.mode === 'dark' ? '106, 80, 63' : '149, 175, 192',
  '--color-interactive':
    theme.palette.mode === 'dark' ? '115, 155, 0' : '140, 100, 255',
  '--color-fill-bg': theme.palette.mode === 'dark' ? '#00b7ff' : '#1a5fea',
  '--circle-size': '200%',
  '--blending': 'hard-light',

  overflow: 'hidden',
  background: 'linear-gradient(40deg, var(--color-bg1), var(--color-bg2))',
  top: 0,
  left: 0,
  right: 0,
  bottom: 0,
  position: 'absolute',
  zIndex: 1,

  '& .fill-bg': {
    position: 'absolute',
    width: '100%',
    height: '100%',
    top: 0,
    left: 0,
    background: 'var(--color-fill-bg)',
    opacity: theme.palette.mode === 'dark' ? 0.5 : 0.4,
    zIndex: 1,
    mixBlendMode: 'color',
    pointerEvents: 'none',
  } as CSSObject,

  '& svg': {
    display: 'none',
  },
  '& .gradients-container': {
    filter: 'url(#goo) blur(40px)',
    width: '100%',
    height: '100%',
  },
  '& .g1': {
    position: 'absolute',
    background:
      'radial-gradient(circle at center, rgba(var(--color1), 0.8) 0, rgba(var(--color1), 0) 50%) no-repeat',
    mixBlendMode: 'var(--blending)',
    width: 'var(--circle-size)',
    height: 'var(--circle-size)',
    top: 'calc(50% - var(--circle-size) / 2)',
    left: 'calc(50% - var(--circle-size) / 2)',
    transformOrigin: 'center center',
    animation: `${moveVertical} 30s ease infinite`,
    opacity: 1,
  },
  '& .g2': {
    position: 'absolute',
    background:
      'radial-gradient(circle at center, rgba(var(--color2), 0.8) 0, rgba(var(--color2), 0) 50%) no-repeat',
    mixBlendMode: 'var(--blending)',
    width: 'var(--circle-size)',
    height: 'var(--circle-size)',
    top: 'calc(50% - var(--circle-size) / 2)',
    left: 'calc(50% - var(--circle-size) / 2)',
    transformOrigin: 'calc(50% - 400px)',
    animation: `${moveInCircle} 20s reverse infinite`,
    opacity: 1,
  },
  '& .g3': {
    position: 'absolute',
    background:
      'radial-gradient(circle at center, rgba(var(--color3), 0.8) 0, rgba(var(--color3), 0) 50%) no-repeat',
    mixBlendMode: 'var(--blending)',
    width: 'var(--circle-size)',
    height: 'var(--circle-size)',
    top: 'calc(50% - var(--circle-size) / 2 + 200px)',
    left: 'calc(50% - var(--circle-size) / 2 - 500px)',
    transformOrigin: 'calc(50% + 400px)',
    animation: `${moveInCircle} 40s linear infinite`,
    opacity: 1,
  },
  '& .g4': {
    position: 'absolute',
    background:
      'radial-gradient(circle at center, rgba(var(--color4), 0.8) 0, rgba(var(--color4), 0) 50%) no-repeat',
    mixBlendMode: 'var(--blending)',
    width: 'var(--circle-size)',
    height: 'var(--circle-size)',
    top: 'calc(50% - var(--circle-size) / 2)',
    left: 'calc(50% - var(--circle-size) / 2)',
    transformOrigin: 'calc(50% - 200px)',
    animation: `${moveHorizontal} 40s ease infinite`,
    opacity: 0.7,
  },
  '& .g5': {
    position: 'absolute',
    background:
      'radial-gradient(circle at center, rgba(var(--color5), 0.8) 0, rgba(var(--color5), 0) 50%) no-repeat',
    mixBlendMode: 'var(--blending)',
    width: 'calc(var(--circle-size) * 2)',
    height: 'calc(var(--circle-size) * 2)',
    top: 'calc(50% - var(--circle-size))',
    left: 'calc(50% - var(--circle-size))',
    transformOrigin: 'calc(50% - 800px) calc(50% + 200px)',
    animation: `${moveInCircle} 20s ease infinite`,
    opacity: 1,
  },
  '& .interactive': {
    position: 'absolute',
    background:
      'radial-gradient(circle at center, rgba(var(--color-interactive), 0.8) 0, rgba(var(--color-interactive), 0) 50%) no-repeat',
    mixBlendMode: 'var(--blending)',
    width: '100%',
    height: '100%',
    top: '-50%',
    left: '-50%',
    opacity: 0.7,
  },
}));
